import { LegalPage } from "@/components/LegalPage";
import { Link } from "@/lib/router-compat";
import { trackEmailClick, trackPhoneClick } from "@/lib/analytics";

const Agb = () => (
  <LegalPage title="Allgemeine Geschäftsbedingungen" path="/agb" subtitle="Stand: September 2026">
    <p>
      Clicks DMP – Design &amp; Media Production · Inhaber: Ashraf AlSalaita · Karl-Traub-Straße 15,
      68199 Mannheim · Telefon{" "}
      <a href="tel:+4917670027200" onClick={() => trackPhoneClick()}>
        +49 176 700 27 200
      </a>{" "}
      ·{" "}
      <a href="mailto:info@clicksdmp.com" onClick={() => trackEmailClick()}>
        info@clicksdmp.com
      </a>
    </p>

    <h2>1. Geltung und Vertragsschluss</h2>
    <p>
      Diese AGB gelten für alle Aufträge an Clicks DMP – Design &amp; Media Production, Inhaber Ashraf
      AlSalaita („wir“), über Fotografie, Videoproduktion, Social-Media-Content, Drohnenaufnahmen und
      damit verbundene Leistungen, gegenüber Unternehmern und Verbrauchern. Leistungsumfang, Preise,
      Anzahlung, Zahlungsziele, Termine, Lieferzeiten, Korrekturrunden, Reisekosten und Laufzeiten
      werden für jeden Auftrag individuell im Angebot vereinbart; das Angebot geht diesen AGB vor. Ein
      Beratungsgespräch ist kostenlos und unverbindlich. Der Vertrag kommt zustande, wenn der
      Auftraggeber das Angebot in Textform (z. B. E-Mail, WhatsApp) annimmt, wenn wir den Auftrag in
      Textform bestätigen oder wenn eine vereinbarte Anzahlung eingeht.
    </p>

    <h2>2. Termine</h2>
    <p>
      Vereinbarte Produktionstermine sind verbindlich. Der Auftraggeber kann einen Termin einmalig
      kostenfrei verschieben, wenn er uns das spätestens sieben Tage vorher in Textform mitteilt; den
      neuen Termin legen wir gemeinsam fest. Außen- und Drohnenaufnahmen, die wegen des Wetters
      ausfallen, holen wir kostenfrei an einem Ersatztermin nach. Eine kostenfreie Stornierung ist nicht
      möglich: Sagt der Auftraggeber die Produktion ab, bleibt die vereinbarte Vergütung geschuldet,
      abzüglich dessen, was wir durch die Absage an Aufwendungen ersparen oder anderweitig erwerben
      (§ 648 BGB); der Nachweis einer höheren Ersparnis bleibt dem Auftraggeber offen. Sind wir selbst
      durch Krankheit oder höhere Gewalt verhindert, bieten wir einen Ersatztermin an; kommt keiner
      zustande, erstatten wir Anzahlungen für nicht erbrachte Leistungen.
    </p>

    <h2>3. Mitwirkung, Einwilligungen, Genehmigungen</h2>
    <p>
      Der Auftraggeber stellt rechtzeitig bereit, was die Produktion braucht (Briefing, Freigaben,
      Zugang, Personen, Produkte, Logos). Er sorgt dafür, dass die von ihm gestellten Personen
      (Mitarbeitende, Kundinnen und Kunden, Gäste, Models) mit den Aufnahmen und der vereinbarten
      Nutzung einverstanden sind, und holt die Genehmigungen für seine Räume und Orte ein. Wir bringen
      eine Einwilligungserklärung zum Produktionstag mit und kümmern uns um die Genehmigungen für unser
      Team, unsere Ausrüstung und unsere Drohnenflüge. Für Materialien, die der Auftraggeber liefert
      (Logos, Texte, Musik, Bilder), sichert er die nötigen Rechte zu. Verletzt der Auftraggeber diese
      Pflichten schuldhaft und werden wir deshalb von Dritten in Anspruch genommen, stellt er uns von
      diesen Ansprüchen frei.
    </p>

    <h2>4. Lieferung, Korrekturen, Rohdaten</h2>
    <p>
      Wir liefern die bearbeiteten finalen Dateien in den vereinbarten Formaten innerhalb der im
      Angebot genannten Zeit, sonst innerhalb einer angemessenen Frist nach dem letzten
      Produktionstag. Rohdaten, unbearbeitetes Material und nicht ausgewählte Aufnahmen werden nicht
      herausgegeben. Im Preis enthalten sind die im Angebot genannten Korrekturrunden, sonst eine; eine
      Korrekturrunde umfasst die gesammelten Änderungswünsche, die uns innerhalb von sieben Tagen nach
      Lieferung des Entwurfs in Textform erreichen. Die künstlerische Gestaltung im Rahmen von Briefing
      und Angebot ist kein Mangel. Für Unternehmer gilt: Offensichtliche Mängel sind innerhalb von 14
      Tagen nach Lieferung in Textform anzuzeigen, und die Nutzung oder Veröffentlichung der Ergebnisse
      gilt als Abnahme. Projektdateien bewahren wir zwölf Monate nach Lieferung auf und dürfen sie
      danach löschen; der Auftraggeber sichert die gelieferten Dateien selbst.
    </p>

    <h2>5. Nutzungsrechte</h2>
    <p>
      Mit vollständiger Zahlung erhält der Auftraggeber an den gelieferten finalen Aufnahmen ein
      einfaches, zeitlich und räumlich unbeschränktes Nutzungsrecht für seine eigene Kommunikation in
      allen Medien; bei Unternehmern sind das Website, Social Media, Print, Präsentationen,
      Vertriebsunterlagen, Werbung einschließlich bezahlter Anzeigen, Messen und interne Nutzung, bei
      Verbrauchern die private Nutzung einschließlich der eigenen Social-Media-Profile. Zuschneiden,
      Skalieren, Plattformformate, Untertitel und das eigene Logo sind erlaubt; weitergehende
      Bearbeitungen, Montagen, Bearbeitung durch KI-Systeme und die Verwendung zum Training von
      KI-Systemen nur mit unserer Zustimmung in Textform (§ 39 UrhG). Die Rechte dürfen nicht an Dritte
      übertragen, unterlizenziert, weiterverkauft oder als Stockmaterial genutzt werden; Agenturen und
      Dienstleister des Auftraggebers dürfen die Aufnahmen für ihn nutzen. Musik, Sprecherstimmen und
      anderes Fremdmaterial nur im Rahmen der von uns erworbenen Lizenz. Ausschließliche Rechte nur nach
      gesonderter Vereinbarung. Vor vollständiger Zahlung ist keine Nutzung erlaubt. Auf die
      Urhebernennung auf den Kanälen des Auftraggebers verzichten wir; eine Markierung (@clicksdmp) ist
      willkommen.
    </p>

    <h2>6. Referenzen</h2>
    <p>
      Bei Unternehmern dürfen wir die Aufnahmen und das Projekt als Referenz zeigen (Website,
      Social-Media-Profile, Präsentationen, Angebote), auch unter Nennung des Auftraggebers, wenn er dem
      nicht vor Produktionsbeginn in Textform widerspricht; ein späterer Widerspruch aus wichtigem Grund
      bleibt möglich, und wir entfernen die Referenz dann innerhalb einer angemessenen Frist. Bei
      Verbrauchern und bei abgebildeten Personen nutzen wir Aufnahmen als Referenz nur mit deren
      gesonderter Einwilligung.
    </p>

    <h2>7. Zahlung</h2>
    <p>
      Preise, Anzahlung und Fälligkeit stehen im Angebot; fehlt dort eine Regel, sind Rechnungen
      innerhalb von 14 Tagen nach Zugang ohne Abzug zu zahlen. Preise gegenüber Unternehmern verstehen
      sich zuzüglich Umsatzsteuer, gegenüber Verbrauchern einschließlich Umsatzsteuer. Bei Verzug gelten
      die gesetzlichen Verzugszinsen. Bis zur vollständigen Zahlung dürfen wir die finalen Dateien
      zurückhalten. Der Auftraggeber kann nur mit unbestrittenen oder rechtskräftig festgestellten
      Forderungen aufrechnen; das gilt nicht für Gegenforderungen aus demselben Vertrag, insbesondere
      wegen Mängeln.
    </p>

    <h2>8. Social-Media-Pakete</h2>
    <p>
      Pakete mit monatlichen Leistungen laufen für die im Angebot genannte Laufzeit; die monatliche
      Vergütung ist im Voraus fällig. Für Unternehmer verlängert sich der Vertrag jeweils um dieselbe
      Laufzeit, wenn er nicht spätestens eine Woche vor Ablauf in Textform gekündigt wird. Für
      Verbraucher läuft der Vertrag nach der Mindestlaufzeit auf unbestimmte Zeit weiter und kann
      jederzeit mit einer Frist von einer Woche in Textform gekündigt werden; im Voraus gezahlte
      Vergütung erstatten wir anteilig. Leistungen eines Monats, die der Auftraggeber nicht abruft,
      verfallen mit dem Monatsende; Verbraucher können sie in den Folgemonat übertragen. Für Unternehmer
      gilt: Bei Zahlungsverzug dürfen wir nach einer Mahnung mit Frist unsere Leistungen zurückhalten,
      bis die Zahlung eingeht; in dieser Zeit vorgesehene Leistungen werden nicht nachgeholt, und die
      Vergütung bleibt abzüglich ersparter Aufwendungen geschuldet. Wir schulden die vereinbarten
      Inhalte und Beratung, nicht einen bestimmten Erfolg; Reichweite, Follower, Anfragen oder Umsätze
      werden nicht zugesichert. Das Recht beider Seiten zur Kündigung aus wichtigem Grund bleibt
      unberührt.
    </p>

    <h2>9. Haftung</h2>
    <p>
      Wir haften unbeschränkt bei Vorsatz und grober Fahrlässigkeit, bei Verletzung von Leben, Körper
      oder Gesundheit, bei arglistig verschwiegenen Mängeln, im Rahmen übernommener Garantien und nach
      dem Produkthaftungsgesetz. Bei leichter Fahrlässigkeit haften wir nur bei Verletzung wesentlicher
      Vertragspflichten und begrenzt auf den vertragstypischen, vorhersehbaren Schaden. Geht
      Aufnahmematerial trotz branchenüblicher Sorgfalt verloren, wiederholen wir die Aufnahmen, soweit
      möglich, auf eigene Kosten. Diese Regeln gelten auch für unsere Erfüllungsgehilfen.
    </p>

    <h2>10. Widerrufsrecht für Verbraucher</h2>
    <p>
      Verbrauchern steht bei Verträgen, die ausschließlich über Fernkommunikationsmittel (z. B.
      Telefon, E-Mail, WhatsApp) oder außerhalb unserer Geschäftsräume geschlossen werden, das folgende
      Widerrufsrecht zu. Wir übermitteln Verbrauchern diese Belehrung und das Formular zusätzlich in
      Textform mit der Auftragsbestätigung.
    </p>

    <div className="legal-box">
      <h3>Widerrufsbelehrung</h3>
      <p>
        <strong>Widerrufsrecht.</strong> Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von
        Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des
        Vertragsabschlusses. Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Clicks DMP – Design &amp;
        Media Production, Ashraf AlSalaita, Karl-Traub-Straße 15, 68199 Mannheim, Telefon +49 176 700
        27 200, E-Mail info@clicksdmp.com) mittels einer eindeutigen Erklärung (z. B. ein mit der Post
        versandter Brief oder eine E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen,
        informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht
        vorgeschrieben ist. Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über
        die Ausübung des Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
      </p>
      <p>
        <strong>Folgen des Widerrufs.</strong> Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle
        Zahlungen, die wir von Ihnen erhalten haben, unverzüglich und spätestens binnen vierzehn Tagen ab
        dem Tag zurückzuzahlen, an dem die Mitteilung über Ihren Widerruf dieses Vertrags bei uns
        eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das Sie bei der
        ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas
        anderes vereinbart; in keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        Haben Sie verlangt, dass die Dienstleistungen während der Widerrufsfrist beginnen sollen, so
        haben Sie uns einen angemessenen Betrag zu zahlen, der dem Anteil der bis zu dem Zeitpunkt, zu
        dem Sie uns von der Ausübung des Widerrufsrechts hinsichtlich dieses Vertrags unterrichten,
        bereits erbrachten Dienstleistungen im Vergleich zum Gesamtumfang der im Vertrag vorgesehenen
        Dienstleistungen entspricht.
      </p>
      <p>
        <strong>Vorzeitiges Erlöschen.</strong> Ihr Widerrufsrecht erlischt vorzeitig, wenn wir die
        Dienstleistung vollständig erbracht haben und mit der Ausführung erst begonnen haben, nachdem
        Sie dazu Ihre ausdrückliche Zustimmung gegeben und gleichzeitig Ihre Kenntnis davon bestätigt
        haben, dass Sie Ihr Widerrufsrecht bei vollständiger Vertragserfüllung durch uns verlieren.
      </p>
    </div>

    <div className="legal-box">
      <h3>Muster-Widerrufsformular</h3>
      <p>(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)</p>
      <p>
        An Clicks DMP – Design &amp; Media Production, Ashraf AlSalaita, Karl-Traub-Straße 15, 68199
        Mannheim, E-Mail info@clicksdmp.com:
      </p>
      <ul>
        <li>
          Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über die
          Erbringung der folgenden Dienstleistung (*)
        </li>
        <li>Bestellt am (*)</li>
        <li>Name des/der Verbraucher(s)</li>
        <li>Anschrift des/der Verbraucher(s)</li>
        <li>Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier)</li>
        <li>Datum</li>
      </ul>
      <p>(*) Unzutreffendes streichen.</p>
    </div>

    <h2>11. Schlussbestimmungen</h2>
    <p>
      Es gilt deutsches Recht; bei Verbrauchern bleiben zwingende Schutzvorschriften ihres
      Aufenthaltsstaates unberührt. Ist der Auftraggeber Kaufmann oder juristische Person des
      öffentlichen Rechts, ist Mannheim Gerichtsstand. Wir sind nicht bereit und nicht verpflichtet, an
      Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen. Sollte eine
      Bestimmung unwirksam sein, bleibt der Vertrag im Übrigen wirksam; es gelten dann die gesetzlichen
      Vorschriften.
    </p>
    <p className="muted">
      Stand: September 2026 · <Link to="/impressum">Impressum</Link> ·{" "}
      <Link to="/datenschutz">Datenschutzerklärung</Link>
    </p>
  </LegalPage>
);

export default Agb;
